import About from "./About";
import Contact from "./Contact";
import Expertise from "./Expertise";
import Main from "./Main";
import Project from "./Project";
import Timeline from "./Timeline";

const paragraphs = [" We are a team of passionate developers dedicated to creating innovative solutions that make a difference. Our expertise spans across various domains, including web development, mobile applications, and AI technologies. We believe in the power of collaboration and strive to deliver high-quality products that exceed expectations.",
  "Our journey began with a shared vision to leverage technology for positive impact. Over the years, we have grown both in size and capabilities, taking on challenging projects that push the boundaries of what is possible. We are committed to continuous learning and adapting to the ever-evolving tech landscape.",
  "Join us as we continue to explore new frontiers and create exceptional digital experiences."
]

function Home() {
  return (
    <>
      <Main />
      <About heading="About Us" paragraphs={paragraphs} />
      <Expertise />
      <Timeline />
      <Project />
      <Contact />
    </>
  );
}

export default Home;
